/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CreateCardAccountRequestIndividualDocumentType = typeof CreateCardAccountRequestIndividualDocumentType[keyof typeof CreateCardAccountRequestIndividualDocumentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCardAccountRequestIndividualDocumentType = {
  passport: 'passport',
  'drivers-license': 'drivers-license',
  'national-id': 'national-id',
} as const;
